// extracted by mini-css-extract-plugin
module.exports = {"imgBox":"products_imgBox__1gQJj","description":"products_description__ibHUv","price":"products_price__3PCJt"};